import { render, staticRenderFns } from "./AssystProblemDialog.vue?vue&type=template&id=3e672717&"
import script from "./AssystProblemDialog.vue?vue&type=script&lang=js&"
export * from "./AssystProblemDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports